<main class="document_viewer" [class.column-view]="twoColumns" style="background-color: white;" role="main"
      aria-label="Pdf viewer, you can use arrow up or down in order to read the document.">
  <div class="document-container" [class.two-columns]="twoColumns">
    <!-- Original PDF viewer -->
    <div class="pdf-viewer-container" [class.half-width]="twoColumns">
      <pdf-viewer
        #viewer
        id="viewer"
        (pagechanging)="pageChanging($event)"
        [src]="pdfSrc"
        [zoom]="zoom"
        [render-text]="true"
        [fit-to-page]="false"
        [external-link-target]="'none'"
        [zoom-scale]="'page-width'"
        [autoresize]="true"
        [page]="selectedPage"
        (page-rendered)="pageRendered($event)"
        [original-size]="false"
        [show-all]="true"
        style="width: 100%; height: 100%;"
        (after-load-complete)="onPdfLoad($event)"
      ></pdf-viewer>
    </div>

    <!-- AI-generated PDF viewer, only shown in two-columns mode -->
    <div class="pdf-viewer-container ai-viewer" *ngIf="twoColumns && secondPdfSrc" [class.half-width]="twoColumns">
      <pdf-viewer
        #viewerSecond
        id="viewerSecond"
        [src]="secondPdfSrc"
        [zoom]="zoom"
        [render-text]="true"
        [fit-to-page]="true"
        [external-link-target]="'none'"
        [zoom-scale]="page-width"
        [autoresize]="true"
        [page]="selectedPage"
        (page-rendered)="pageRendered($event)"
        [original-size]="false"
        [show-all]="true"
        style="width: 100%; height: 100%;"
      ></pdf-viewer>
    </div>
  </div>

  <div *ngIf="showStylometrics" style="overflow-y: scroll !important;">
    <pre>{{ submission?.stylometricsData | json }}</pre>
    <pre>{{ submission?.stylometricsJson | json }}</pre>
  </div>

  <!-- <section class="pdf_btns">
    <button (click)="zoomIn()">+</button>
    <button (click)="zoomOut()">-</button>
  </section> -->

  <!-- Add a floating control button for side-by-side view -->
  <!-- <div *ngIf="twoColumns" class="side-by-side-controls">
    <button class="close-side-by-side" (click)="closeSideBySideView()">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Close comparison
    </button>
  </div> -->
</main>
